<template>
  <svg
    width="52"
    height="50"
    viewBox="0 0 52 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.6617 34.1906C36.5509 34.1906 43.757 26.9845 43.757 18.0953C43.757 9.2061 36.5509 2 27.6617 2C18.7725 2 11.5664 9.2061 11.5664 18.0953C11.5664 26.9845 18.7725 34.1906 27.6617 34.1906Z"
      fill="#E7EEF1"
    />
    <path
      d="M17.1995 22.1191H5.12808V23.7287H3.51855V26.9477H5.12808V39.0192H17.1995V22.1191Z"
      fill="white"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M7.54297 14.0714V22.1191"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M10.7617 18.0953V22.1192"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.34766 25.3381H9.95718"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M33.2949 25.3381H22.833V31.7762H33.2949V25.3381Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M22.833 25.3381H12.3711V31.7762H22.833V25.3381Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M43.7569 25.3381H33.2949V31.7762H43.7569V25.3381Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M27.6621 18.9001H17.2002V25.3383H27.6621V18.9001Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M38.124 18.9001H27.6621V25.3383H38.124V18.9001Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M30.0758 29.3621L25.2473 31.7763C25.2473 31.7763 6.13411 31.7763 2.71387 31.7763V37.4097C2.71387 39.0192 3.09211 40.0413 3.62325 40.7897L4.2912 40.2505C5.04768 39.6389 6.03754 39.6952 6.74574 40.3793L8.12993 41.7152C8.42769 42.0049 8.77374 42.1739 9.12784 42.2383H9.73946C10.0533 42.1819 10.3511 42.0451 10.6247 41.8118L12.4274 40.2747C13.1678 39.6469 14.1576 39.6711 14.8739 40.331L16.4351 41.7635C16.7087 42.0129 17.0226 42.1739 17.3445 42.2383H18.0205C18.3424 42.1739 18.6482 42.021 18.9218 41.7796L20.5555 40.3149C21.2798 39.663 22.2696 39.655 23.002 40.2907L24.7403 41.7957C25.0139 42.029 25.3197 42.1739 25.6255 42.2302H26.2613C26.6073 42.1658 26.9373 42.0049 27.227 41.7313L28.6756 40.3551C29.3838 39.6791 30.3817 39.6389 31.1301 40.2586L33.0374 41.8278C33.303 42.0451 33.6088 42.1819 33.9146 42.2302H34.486C34.8642 42.1658 35.2263 41.9888 35.5322 41.683L36.8037 40.4034C37.5038 39.7033 38.5017 39.6308 39.2663 40.2264L40.6746 41.3289C41.6645 37.9891 47.7646 35.3656 47.7646 29.354H30.0758V29.3621Z"
      fill="#6BFFFF"
    />
    <path
      d="M40.6424 41.4335C41.5437 38.0455 47.7807 35.43 47.7807 29.3621H30.0759L25.2473 31.7764C25.2473 31.7764 6.13412 31.7764 2.71387 31.7764V37.4097C2.71387 38.9227 3.03577 39.9206 3.51863 40.6529"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M47.7807 14.8761H41.6725C41.2621 13.9587 40.2883 13.2344 39.1617 13.2344C38.7995 13.2344 38.4615 13.3149 38.1477 13.4436C37.52 11.7697 35.9024 10.5143 34.0031 10.5143C31.5647 10.5143 29.585 13.0412 29.5769 14.8761H25.2393"
      stroke="#465363"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M16.395 11.6571H11.9688C11.9688 9.65322 10.3512 8.03564 8.34737 8.03564C6.34351 8.03564 4.72593 9.65322 4.72593 11.6571H1.10449"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M18.8096 7.6333H28.4667"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M42.6787 42.8982L39.2746 40.2344C38.5101 39.6389 37.5121 39.7113 36.812 40.4114L35.5405 41.691C34.8242 42.4073 33.8102 42.4636 33.0457 41.8359L31.1384 40.2666C30.39 39.655 29.4001 39.6872 28.6839 40.3632L27.2353 41.7393C26.511 42.4314 25.497 42.4555 24.7405 41.8037L23.0023 40.2988C22.2699 39.663 21.2801 39.6711 20.5558 40.3229L18.9221 41.7876C18.1817 42.4555 17.1677 42.4475 16.4273 41.7715L14.8661 40.339C14.1498 39.6791 13.16 39.655 12.4196 40.2827L10.6169 41.8198C9.86045 42.4636 8.84645 42.4234 8.12216 41.7232L6.73797 40.3873C6.02978 39.7032 5.03992 39.6469 4.28344 40.2585L1 42.9062"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M51 47.7267L47.5959 45.0629C46.8313 44.4674 45.8334 44.5398 45.1333 45.2399L43.8618 46.5195C43.1455 47.2357 42.1315 47.2921 41.367 46.6644L39.4597 45.0951C38.7113 44.4835 37.7214 44.5237 37.0052 45.1916L35.5566 46.5678C34.8323 47.2599 33.8183 47.284 33.0618 46.6322L31.3235 45.1273C30.5912 44.4915 29.6013 44.4995 28.8771 45.1514L27.2434 46.6161C26.503 47.284 25.489 47.276 24.7486 46.6L23.1874 45.1675C22.4711 44.5076 21.4813 44.4835 20.7409 45.1112L18.9382 46.6483C18.1817 47.2921 17.1677 47.2518 16.4435 46.5517L15.0593 45.2158C14.3511 44.5317 13.3612 44.4754 12.6047 45.087L9.32129 47.7347"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M33.2952 32.5811H30.8809"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
